import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { HeartPulse, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import PasswordInput from "@/components/PasswordInput";
import { api, apiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Las contraseñas no coinciden"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Contraseña actualizada. Inicia sesión.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-6">
        <Link to="/" className="mb-8 flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#0284C7] text-white"><HeartPulse className="h-5 w-5" strokeWidth={2.6} /></div>
          <span className="text-lg font-extrabold tracking-tight text-slate-900">SaludCitaRD</span>
        </Link>
        <div className="rounded-2xl border border-[#E2E8F0] bg-white p-8">
          <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-sky-50 text-[#0284C7]"><KeyRound className="h-5 w-5" /></div>
          <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">Nueva contraseña</h1>
          {!token ? (
            <p className="mt-2 text-sm font-semibold text-red-500" data-testid="reset-no-token">Enlace inválido. Solicita uno nuevo desde "Olvidé mi contraseña".</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Nueva contraseña</Label>
                <PasswordInput required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5 rounded-xl border-[#E2E8F0]" data-testid="reset-pw-input" />
              </div>
              <div>
                <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Confirmar contraseña</Label>
                <PasswordInput required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1.5 rounded-xl border-[#E2E8F0]" data-testid="reset-pw2-input" />
              </div>
              <Button type="submit" disabled={busy} className="w-full rounded-full bg-[#0284C7] font-bold hover:bg-[#0369a1]" data-testid="reset-submit-btn">
                {busy ? "Guardando…" : "Restablecer contraseña"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
